export default __webpack_public_path__ + "static/media/cimb.face52ad.svg";